module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-92.b09a8e4e.jpg";